import Skeleton from "@mui/material/Skeleton";
const TrainerHelpCenterSkeleton = () => {
  return (
    
      <Skeleton variant="text" animation="wave" className="w-full " height={96.6} sx={{marginTop:'16px'}} />
  );
};
export default TrainerHelpCenterSkeleton;
